import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  t,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class PartsWithdraw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_type: "",
      filter_status: "",

      count: 421,
      page: 1,
      page_size: 10,

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,

      // Form States (for Modal "เบิกอะไหล่ใหม่")
      form_withdraw_type: "เบิกล่วงหน้า",
      form_ref_doc: "",
      form_withdraw_for: "Somchai Jaidee (VAN-001)",
      form_priority: "ปกติ",
      form_note: "",
      
      // Items in Modal
      form_withdraw_items: [
        { id: "PRT-002456", desc: "Filter Element 10 Micron", available: 33, qty: 2, location: "WH-A / R2-S1" },
        { id: "PRT-003789", desc: "Bearing 6205-2RS", available: 103, qty: 5, location: "WH-B / R1-S3" }
      ],

      // -----------------------------------
      // Mock Data: Summary Stats (ตามรูป image_264b9f.jpg)
      // -----------------------------------
      summary: {
        waiting_pick: 12,
        processing: 5,
        completed_today: 847,
        urgent: 2,
      },

      // -----------------------------------
      // Mock Data: Withdraw Table List
      // -----------------------------------
      data: [
        {
          id: "ISS-2025-0421",
          type: "เบิกล่วงหน้า", typeColor: "primary",
          ref_doc: "WO-20250111-0003",
          requester: "Admin Dispatcher",
          items_count: 5,
          time_ago: "10 นาทีที่แล้ว",
          priority: "เร่งด่วน", priorityColor: "danger",
          status: "รอดำเนินการ", statusColor: "warning",
          can_edit: true, can_print: true, can_start: true
        },
        {
          id: "ISS-2025-0420",
          type: "เติมรถช่าง", typeColor: "purple",
          ref_doc: "VAN-003 (Wichai)",
          requester: "Wichai Srisuk",
          items_count: 12,
          time_ago: "25 นาทีที่แล้ว",
          priority: "สูง", priorityColor: "warning",
          status: "กำลังหยิบ", statusColor: "primary",
          can_complete: true
        },
        {
          id: "ISS-2025-0419",
          type: "เบิกล่วงหน้า", typeColor: "primary",
          ref_doc: "WO-20250111-0002",
          requester: "Admin Dispatcher",
          items_count: 3,
          time_ago: "1 ชั่วโมงที่แล้ว",
          priority: "ปกติ", priorityColor: "primary",
          status: "พร้อม", statusColor: "success",
          can_view: true
        },
        {
          id: "ISS-2025-0418",
          type: "เบิกเฉพาะกิจ", typeColor: "secondary",
          ref_doc: "Internal Use",
          requester: "WH Admin",
          items_count: 2,
          time_ago: "2 ชั่วโมงที่แล้ว",
          priority: "ต่ำ", priorityColor: "secondary",
          status: "เบิกแล้ว", statusColor: "dark",
          can_view: true, can_print: true
        }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  Get = async (page) => {
    // API logic will go here
  }

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };
render() {
    const { 
      data, count, summary, 
      filter_search, filter_type, filter_status,
      modal_create, form_withdraw_type, form_ref_doc, form_withdraw_for, form_priority, form_note, form_withdraw_items
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
            <div className="mb-4">
              <h3 className="fw-bold mb-1 text-dark">{t("withdraw_parts")}</h3>
              <div className="text-secondary text-14">{t("withdraw_parts_desc")}</div>
            </div>

          {/* Top Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf46d"}</div>
                  <div><h3 className="fw-bold text-dark mb-0">{summary.waiting_pick}</h3><div className="text-secondary text-12 fw-bold">{t("waiting_pick")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf466"}</div>
                  <div><h3 className="fw-bold text-warning mb-0">{summary.processing}</h3><div className="text-secondary text-12 fw-bold">{t("processing")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                  <div><h3 className="fw-bold text-success mb-0">{summary.completed_today}</h3><div className="text-secondary text-12 fw-bold">{t("completed_today")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{"\uf071"}</div>
                  <div><h3 className="fw-bold text-danger mb-0">{summary.urgent}</h3><div className="text-secondary text-12 fw-bold">{t("urgent")}</div></div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex gap-3 flex-wrap flex-grow-1">
                <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                  <input type="text" className="form-control ps-5 wpx-300" placeholder={t("search_withdraw_no")} />
                </div>
                <select className="form-select wpx-150">
                  <option>{t("all_types")}</option>
                </select>
                <select className="form-select wpx-150">
                  <option>{t("all_statuses")}</option>
                </select>
              </div>
              <button 
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" 
                style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                onClick={() => this.setState({ modal_create: true })}
              >
                <span className="me-2 text-16">+</span> {t("new_withdraw")}
              </button>
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm pb-2">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-4 border-0 wpx-180">{t("withdraw_no")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("type")}</th>
                    <th className="py-3 border-0 text-center wpx-200">{t("reference")}</th>
                    <th className="py-3 border-0 text-center wpx-150">{t("requester")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("items")}</th>
                    <th className="py-3 border-0 text-center wpx-150">{t("requested_at")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("priority")}</th>
                    <th className="py-3 border-0 text-center wpx-150">{t("status")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className={`border-bottom border-light ${item.priority === 'เร่งด่วน' ? 'bg-danger-light' : 'bg-white'}`}>
                      <td className="py-3 px-4 fw-bold text-primary pointer hover-underline font-monospace">{item.id}</td>
                      <td className="text-center"><span className={`badge bg-${item.typeColor}-light text-${item.typeColor} rounded-2 px-2 py-1 text-10 border`}>{item.type}</span></td>
                      <td className="text-center text-secondary text-14">{item.ref_doc}</td>
                      <td className="text-center text-dark text-14">{item.requester}</td>
                      <td className="text-center fw-bold text-dark text-14">{item.items_count}</td>
                      <td className="text-center text-secondary text-14">{item.time_ago}</td>
                      <td className="text-center"><span className={`text-${item.priorityColor} text-12 fw-bold bg-${item.priorityColor}-light px-2 py-1 rounded-pill`}>{item.priority}</span></td>
                      <td className="text-center"><span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.statusColor}`}>{item.status}</span></td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" />
                          {item.can_start && <ActionIconButton label={t("start")} icon={ACTION_ICONS.play} variant="primary" />}
                          {item.can_complete && <ActionIconButton label={t("complete")} icon={"\uf00c"} variant="success" />}
                          {item.can_print && <ActionIconButton label={t("print")} icon={"\uf02f"} variant="primary" />}
                          {item.can_edit && <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" />}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
              <div>{t("showing")} 1-{data.length} {t("of")} {count} {t("records")}</div>
              <Pagination count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
            </div>
          </div>
        </div>

        {/* MODAL: เบิกอะไหล่ใหม่ */}
        <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
          <Modal.Header className="bg-white border-bottom-0 pb-0 pt-4 px-4" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("new_withdraw_modal_title")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white" >
            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("withdraw_type_label")} <span className="text-danger">{t("required_field")}</span></label>
                <select className="form-select py-2" value={form_withdraw_type} onChange={(e) => this.setState({ form_withdraw_type: e.target.value })}>
                  <option value="เบิกล่วงหน้า">{t("advanced_withdraw")}</option>
                  <option value="เติมรถช่าง">{t("van_restock")}</option>
                  <option value="เบิกเฉพาะกิจ">{t("ad_hoc_withdraw")}</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("reference")} <span className="text-danger">{t("required_field")}</span></label>
                <input type="text" className="form-control py-2" placeholder={t("ref_wo_van_id")} value={form_ref_doc} onChange={(e) => this.setState({ form_ref_doc: e.target.value })} />
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("withdraw_for_label")}</label>
                <select className="form-select py-2" value={form_withdraw_for} onChange={(e) => this.setState({ form_withdraw_for: e.target.value })}>
                  <option>{form_withdraw_for}</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("priority")}</label>
                <select className="form-select py-2" value={form_priority} onChange={(e) => this.setState({ form_priority: e.target.value })}>
                  <option value="ปกติ">{t("normal")}</option>
                  <option value="สูง">{t("high")}</option>
                  <option value="เร่งด่วน">{t("urgent")}</option>
                </select>
              </div>
            </div>

            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold text-dark mb-0">{t("withdraw_items_list")}</h6>
                <button className="btn btn-sm text-primary fw-bold d-flex align-items-center px-0"><span className="me-1">+</span> {t("add_item")}</button>
              </div>
              <div className="table-responsive bg-light p-2 rounded-3 border border-light">
                <table className="table align-middle mb-0 border-0 text-12">
                  <thead>
                    <tr className="text-dark fw-bold">
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("part_code")}</th>
                      <th className="py-2 border-0 bg-transparent wpx-200">{t("description")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("available")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-100">{t("withdraw_qty")}</th>
                      <th className="py-2 border-0 bg-transparent wpx-150">{t("location")}</th>
                      <th className="py-2 border-0 bg-transparent text-center wpx-40"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {form_withdraw_items.map((item, idx) => (
                      <tr key={idx} className="bg-transparent border-bottom border-white">
                        <td className="py-2 px-1"><select className="form-select form-select-sm rounded-2 border-light"><option>{item.id}</option></select></td>
                        <td className="py-2 text-secondary px-1">{item.desc}</td>
                        <td className="py-2 text-center text-success fw-bold px-1">{item.available}</td>
                        <td className="py-2 px-1"><input type="number" className="form-control form-control-sm text-center rounded-2 border-light" value={item.qty} /></td>
                        <td className="py-2 text-secondary text-12 px-1">{item.location}</td>
                        <td className="py-2 text-center px-1"><span className="icon text-danger pointer text-14">{"\uf2ed"}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <label className="form-label text-14 text-dark fw-bold mb-2">{t("note_label")}</label>
              <textarea className="form-control py-2" rows="3" placeholder={t("additional_notes")} value={form_note} onChange={(e) => this.setState({ form_note: e.target.value })}></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_create: false })}>{t("cancel")}</button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm d-flex align-items-center" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}>
              <span className="icon me-2">{"\uf02f"}</span> {t("create_print_pick_slip")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}